<section class="panel h1-a0-md1">
    <section class="header-zone">
        <ng-content select="[header-zone]"></ng-content>
    </section>
    <section class="data-zone">
        <ng-content select="[data-zone]"></ng-content>
    </section>
</section>
